/**
 * NativeWaves Media API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class MediaChannelsApi extends runtime.BaseAPI {
    /**
     * Perform an audio query against the channel.
     */
    async channelsChannelIdAudioQueriesPostRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdAudioQueriesPost.');
        }
        if (requestParameters.mediaChannelAudioQueryInsert === null ||
            requestParameters.mediaChannelAudioQueryInsert === undefined) {
            throw new runtime.RequiredError('mediaChannelAudioQueryInsert', 'Required parameter requestParameters.mediaChannelAudioQueryInsert was null or undefined when calling channelsChannelIdAudioQueriesPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}/audioQueries`.replace(`{${'channelId'}}`, String(requestParameters.channelId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mediaChannelAudioQueryInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Perform an audio query against the channel.
     */
    async channelsChannelIdAudioQueriesPost(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdAudioQueriesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a media channel.
     */
    async channelsChannelIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}`.replace(`{${'channelId'}}`, String(requestParameters.channelId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a media channel.
     */
    async channelsChannelIdDelete(requestParameters, initOverrides) {
        await this.channelsChannelIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a media channel.
     */
    async channelsChannelIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}`.replace(`{${'channelId'}}`, String(requestParameters.channelId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a media channel.
     */
    async channelsChannelIdGet(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a media channel.
     */
    async channelsChannelIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdPatch.');
        }
        if (requestParameters.mediaChannelEdit === null ||
            requestParameters.mediaChannelEdit === undefined) {
            throw new runtime.RequiredError('mediaChannelEdit', 'Required parameter requestParameters.mediaChannelEdit was null or undefined when calling channelsChannelIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}`.replace(`{${'channelId'}}`, String(requestParameters.channelId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mediaChannelEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a media channel.
     */
    async channelsChannelIdPatch(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a media channel entry.
     */
    async channelsChannelIdScheduleEntryIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdScheduleEntryIdDelete.');
        }
        if (requestParameters.entryId === null ||
            requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling channelsChannelIdScheduleEntryIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}/schedule/{entryId}`
                .replace(`{${'channelId'}}`, String(requestParameters.channelId))
                .replace(`{${'entryId'}}`, String(requestParameters.entryId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a media channel entry.
     */
    async channelsChannelIdScheduleEntryIdDelete(requestParameters, initOverrides) {
        await this.channelsChannelIdScheduleEntryIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a media channel entry.
     */
    async channelsChannelIdScheduleEntryIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdScheduleEntryIdGet.');
        }
        if (requestParameters.entryId === null ||
            requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling channelsChannelIdScheduleEntryIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}/schedule/{entryId}`
                .replace(`{${'channelId'}}`, String(requestParameters.channelId))
                .replace(`{${'entryId'}}`, String(requestParameters.entryId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a media channel entry.
     */
    async channelsChannelIdScheduleEntryIdGet(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdScheduleEntryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit media channel entry.
     */
    async channelsChannelIdScheduleEntryIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdScheduleEntryIdPatch.');
        }
        if (requestParameters.entryId === null ||
            requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId', 'Required parameter requestParameters.entryId was null or undefined when calling channelsChannelIdScheduleEntryIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}/schedule/{entryId}`
                .replace(`{${'channelId'}}`, String(requestParameters.channelId))
                .replace(`{${'entryId'}}`, String(requestParameters.entryId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mediaChannelScheduleEntryEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit media channel entry.
     */
    async channelsChannelIdScheduleEntryIdPatch(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdScheduleEntryIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of entries of a media channel.
     */
    async channelsChannelIdScheduleGetRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdScheduleGet.');
        }
        const queryParameters = {};
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.libraryId !== undefined) {
            queryParameters['libraryId'] = requestParameters.libraryId;
        }
        if (requestParameters.manifestId !== undefined) {
            queryParameters['manifestId'] = requestParameters.manifestId;
        }
        if (requestParameters.channelPosition !== undefined) {
            queryParameters['channelPosition'] = requestParameters.channelPosition;
        }
        if (requestParameters.groups) {
            queryParameters['groups'] = requestParameters.groups;
        }
        if (requestParameters.excludeGrouped !== undefined) {
            queryParameters['excludeGrouped'] = requestParameters.excludeGrouped;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}/schedule`.replace(`{${'channelId'}}`, String(requestParameters.channelId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of entries of a media channel.
     */
    async channelsChannelIdScheduleGet(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdScheduleGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a media channel entry.
     */
    async channelsChannelIdSchedulePostRaw(requestParameters, initOverrides) {
        if (requestParameters.channelId === null ||
            requestParameters.channelId === undefined) {
            throw new runtime.RequiredError('channelId', 'Required parameter requestParameters.channelId was null or undefined when calling channelsChannelIdSchedulePost.');
        }
        if (requestParameters.mediaChannelScheduleEntryInsert === null ||
            requestParameters.mediaChannelScheduleEntryInsert === undefined) {
            throw new runtime.RequiredError('mediaChannelScheduleEntryInsert', 'Required parameter requestParameters.mediaChannelScheduleEntryInsert was null or undefined when calling channelsChannelIdSchedulePost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels/{channelId}/schedule`.replace(`{${'channelId'}}`, String(requestParameters.channelId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mediaChannelScheduleEntryInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a media channel entry.
     */
    async channelsChannelIdSchedulePost(requestParameters, initOverrides) {
        const response = await this.channelsChannelIdSchedulePostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of media channels. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async channelsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling channelsGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of media channels. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async channelsGet(requestParameters, initOverrides) {
        const response = await this.channelsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new media channel.
     */
    async channelsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.mediaChannelInsert === null ||
            requestParameters.mediaChannelInsert === undefined) {
            throw new runtime.RequiredError('mediaChannelInsert', 'Required parameter requestParameters.mediaChannelInsert was null or undefined when calling channelsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/channels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.mediaChannelInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new media channel.
     */
    async channelsPost(requestParameters, initOverrides) {
        const response = await this.channelsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ChannelsChannelIdScheduleGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const ChannelsGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
//# sourceMappingURL=MediaChannelsApi.js.map